import React from 'react';

import { useSelector } from 'react-redux';
import { selectFilterSort, setSort } from '../redux/slices/filterSlice';
import { sortNames } from '../config/sortNames';
import { useAppDispatch } from '../redux/store';

const Sort: React.FC = () => {
	const dispatch = useAppDispatch();
	const sort = useSelector(selectFilterSort);
	const sortRef = React.useRef<HTMLDivElement>(null);
	const [open, setOpen] = React.useState(false);

	const onClickListItem = (obj: any) => {
		dispatch(setSort(obj));
		setOpen(false);
	};

	React.useEffect(() => {
		const hansleClickOutside = (evt: MouseEvent) => {
			const _evt = evt as MouseEvent & {
				path: Node[];
			};
			if (sortRef.current && !_evt.composedPath().includes(sortRef.current)) {
				setOpen(false);
			}
		};
		document.body.addEventListener('click', hansleClickOutside);

		return () => document.body.removeEventListener('click', hansleClickOutside);
	}, []);

	return (
		<div ref={sortRef} className="sort">
			<div className="sort__label">
				<svg
					width="10"
					height="6"
					viewBox="0 0 10 6"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10 5C10 5.16927 9.93815 5.31576 9.81445 5.43945C9.69075 5.56315 9.54427 5.625 9.375 5.625H0.625C0.455729 5.625 0.309245 5.56315 0.185547 5.43945C0.061849 5.31576 0 5.16927 0 5C0 4.83073 0.061849 4.68424 0.185547 4.56055L4.56055 0.185547C4.68424 0.061849 4.83073 0 5 0C5.16927 0 5.31576 0.061849 5.43945 0.185547L9.81445 4.56055C9.93815 4.68424 10 4.83073 10 5Z"
						fill="#2C2C2C"
					/>
				</svg>
				<b>Сортировка по:</b>
				<span
					onClick={() => {
						setOpen(!open);
					}}
				>
					{sort.name}
				</span>
			</div>
			{open && (
				<div className="sort__popup active">
					<ul>
						{sortNames.map((data, i) => (
							<li
								key={i}
								onClick={() => {
									onClickListItem(data);
								}}
								className={
									sort.sortProperty === data.sortProperty ? 'active' : ''
								}
							>
								{data.name}
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default Sort;
